export default function(element) {
  element.disabled = true;
  element.classList.add("disabled");
}
